import * as Phaser from 'phaser';

/** Отдельное изображение: деформация никогда не меняет Arcade Body. */
export class CharacterVisual {
  private readonly image: Phaser.GameObjects.Image;
  private elapsed = 0;
  private impulse = 0;

  constructor(private readonly sprite: Phaser.Physics.Arcade.Sprite) {
    this.image = sprite.scene.add.image(sprite.x, sprite.y, sprite.texture.key);
    sprite.setData('characterVisual', this);
    sprite.once('destroy', () => this.image.destroy());
  }

  public react(): void { this.impulse = 0.15; }

  public reset(): void {
    this.impulse = 0;
    this.elapsed = 0;
    this.image.setVisible(false);
  }

  public update(dt: number): void {
    const sprite = this.sprite;
    if (!sprite.active) { this.reset(); return; }
    this.elapsed += dt;
    this.impulse = Math.max(0, this.impulse - dt);
    const velocity = (sprite.body as Phaser.Physics.Arcade.Body)?.velocity;
    const moving = velocity && Math.hypot(velocity.x, velocity.y) > 5;
    const hop = moving ? Math.abs(Math.sin(this.elapsed * 11)) * 3 : Math.sin(this.elapsed * 2) * 0.5;
    const squash = this.impulse * 0.5;
    if (this.image.texture.key !== sprite.texture.key || this.image.frame.name !== sprite.frame.name) this.image.setTexture(sprite.texture.key, sprite.frame.name);
    const width = sprite.displayWidth * (1 + squash), height = sprite.displayHeight * (1 - squash);
    if (this.image.displayWidth !== width || this.image.displayHeight !== height) this.image.setDisplaySize(width, height);
    if (this.image.tintTopLeft !== sprite.tintTopLeft || this.image.tintTopRight !== sprite.tintTopRight || this.image.tintBottomLeft !== sprite.tintBottomLeft || this.image.tintBottomRight !== sprite.tintBottomRight) this.image.setTint(sprite.tintTopLeft, sprite.tintTopRight, sprite.tintBottomLeft, sprite.tintBottomRight);
    this.image.setVisible(true).setPosition(sprite.x, sprite.y - hop)
      .setRotation(moving ? Math.sin(this.elapsed * 11) * 0.055 : 0)
      .setFlip(sprite.flipX, sprite.flipY).setAlpha(sprite.alpha)
      .setDepth(sprite.depth);
    sprite.setVisible(false);
  }
}
